import { render } from "./ThirdSection.vue?vue&type=template&id=34c91eee&scoped=true"
const script = {}

import "./ThirdSection.vue?vue&type=style&index=0&id=34c91eee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c91eee"]])

export default __exports__